/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { Dialog, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { IErrorList, IErrorProps } from "../../models";
import "./ErrorDialogForServerError.scss";
import { PrimaryBtn } from "../../utils/buttons/Buttons";
import LogoutUser from "../../utils/methods/logout/LogoutUser";
import { Button } from "@forge/common";
interface IDialogForErrorProps {
  open: boolean;
  onClose(): void;
  errorList: Array<IErrorProps>;
  errorType:
    | "serverError"
    | "noURLFoundError"
    | "noAccessError"
    | "conflictError";
}

const DialogForError = (props: IDialogForErrorProps) => {
  const [logoutUser, setLogoutUser] = useState(false);
  let errorBody = "This could be because:";
  let image1 = "";
  let messageHints: string[] = [];
  let header: string = "";
  const { open, onClose, errorList, errorType } = props;
  useEffect(() => {}, [props.errorList]);
  const isAnyNoURLError = errorList?.find(
    (x) => x?.errorCode > 500 || x?.errorCode === undefined
  );

  if (isAnyNoURLError || errorType === "noURLFoundError") {
    image1 = require("../../images/imagePageNotFound.png");
    header = "NO URL FOUND";
  } else if (errorType === "serverError") {
    image1 = require("../../images/imageServerError.png");
    header = "SOMETHING WENT WRONG";
  } else if (errorType === "noAccessError") {
    image1 = require("../../images/imageNoAccess.png");
    header = "FORBIDDEN : YOU NEED PERMISSIONS";
    errorBody = "";
  } else if (errorType === "conflictError") {
    image1 = require("../../images/imageServerError.png");
    header = "DATA CONFLICT";
    errorBody = "Another user has modified the data. Please refresh the page.";
  } else {
  }

  errorList?.forEach((element: IErrorProps, index) => {
    const { errorCode, errorMessage } = element;

    if (errorType === "noURLFoundError" && errorCode === undefined) {
      messageHints = [
        "The page you're looking for appears to have been moved,deleted or doesn't exist.",
      ];
    } else if (
      errorType === "serverError" &&
      errorCode !== null &&
      errorCode !== 400 &&
      errorCode !== undefined
    ) {
      if (
        messageHints?.find(
          (x) => x === "" || x.toLowerCase() === errorMessage.toLowerCase()
        )
      ) {
      } else {
        const newErrorMessages = [...messageHints, errorMessage];
        messageHints = newErrorMessages;
      }
    } else if (errorType === "noAccessError") {
      const newErrorMessages = [...messageHints, errorMessage];
      messageHints = newErrorMessages;
    } else {
    }
  });

  /**
   * To show the logout button on the popup incase the loggedin user
   * doesn't have access to UDP Admin portal
   * on Logout button click, user will be signed out and redirects to Sign in page
   */
  let logoutBtnJsx = null;
  if (errorType === "noAccessError") {
    logoutBtnJsx = (
      <Grid container justifyContent="flex-end" sx={{ padding: "24px" }}>
        <PrimaryBtn
          btnText="Logout"
          onClick={() => setLogoutUser(true)}
          ariaLabel=""
        />
      </Grid>
    );
  }

  const DialogForError = (
    <Dialog
      sx={{
        zIndex: "99999 !important",
      }}
      open={open}
      onClose={onClose}
      style={{ alignSelf: "center" }}
      className="eror-Popup"
    >
      <div className="card">
        <div className="image-div">
          <img src={image1} alt="Image1" />
        </div>
        <div className="content p-5">
          <p className="heading-type p-10">{header}</p>
          <p className="content-Style p-10">{errorBody}</p>
          <ol className="ordered-List">
            {messageHints.map((messageHint, index) => (
              <li key={index} className="content-Style ">
                {messageHint}
              </li>
            ))}
          </ol>
          <Grid container justifyContent="flex-end">
            {errorType != "noAccessError" && (
              <Button
                className="okButton"
                onClick={() => {
                  props.onClose();
                }}
              >
                Okay
              </Button>
            )}
          </Grid>
          {logoutBtnJsx}
          {logoutUser && <LogoutUser />}
        </div>
      </div>
    </Dialog>
  );

  return <>{open && DialogForError}</>;
};
export default DialogForError;
